var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { "min-width": "1200px" } },
    [
      _c("div", { staticClass: "form-card-wrapper" }, [
        _c("div", { staticClass: "section form-row" }, [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Warehouse2")))
          ]),
          _c(
            "div",
            { staticClass: "warehouse-wrap" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": _vm.isZh ? "100px" : "234px",
                    "label-position": _vm.isEn ? "right" : "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.LoadingCharge2") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "1",
                          disabled: !_vm.chargeEnable,
                          precision: 2,
                          min: 0,
                          max: 999999999999,
                          "controls-position": "right"
                        },
                        on: { change: _vm.dealPackingCharge },
                        model: {
                          value: _vm.packingChargeAmount,
                          callback: function($$v) {
                            _vm.packingChargeAmount = $$v
                          },
                          expression: "packingChargeAmount"
                        }
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.localCurrency))]),
                      _vm.isZh
                        ? [
                            _c("label", { staticStyle: { margin: "0 10px" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.RmbNumberOfDamagedAndDamp")
                                )
                              )
                            ]),
                            _c("el-input-number", {
                              attrs: {
                                no: "2",
                                precision: 0,
                                min: 0,
                                max: 999999999999,
                                "controls-position": "right"
                              },
                              model: {
                                value: _vm.warehouseInfo.quantity,
                                callback: function($$v) {
                                  _vm.$set(_vm.warehouseInfo, "quantity", $$v)
                                },
                                expression: "warehouseInfo.quantity"
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  !_vm.isZh
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.RmbNumberOfDamagedAndDamp2"
                            )
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              no: "3",
                              precision: 0,
                              min: 0,
                              max: 999999999999,
                              "controls-position": "right"
                            },
                            model: {
                              value: _vm.warehouseInfo.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseInfo, "quantity", $$v)
                              },
                              expression: "warehouseInfo.quantity"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.warehouseCmpLabel }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "4",
                          "method-params": { warehouse: true, active: true },
                          "default-value": _vm.warehouseInfo.warehouseCmp || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.warehouseInfo.warehouseCmp = p.value || 0
                            _vm.warehouseChangeHandler(p.value || 0)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.openWarehouse
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.WareHouseName") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "5",
                                "allow-create": true,
                                filterable: ""
                              },
                              on: { change: _vm.nameChangeHandler },
                              model: {
                                value: _vm.warehouseInfo.warehouseName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.warehouseInfo,
                                    "warehouseName",
                                    $$v
                                  )
                                },
                                expression: "warehouseInfo.warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") } },
                    [
                      _c("el-input", {
                        attrs: { no: "6" },
                        model: {
                          value: _vm.warehouseInfo.warehouseContactTel,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.warehouseInfo,
                              "warehouseContactTel",
                              $$v
                            )
                          },
                          expression: "warehouseInfo.warehouseContactTel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "label-none custom",
                      attrs: { label: _vm.$t("SeaExport.Fax") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "7" },
                        model: {
                          value: _vm.warehouseInfo.warehouseContactFax,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.warehouseInfo,
                              "warehouseContactFax",
                              $$v
                            )
                          },
                          expression: "warehouseInfo.warehouseContactFax"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.WarehouseAddress") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "8",
                          type: "textarea",
                          rows: 5,
                          "filter-chars": false
                        },
                        model: {
                          value: _vm.warehouseInfo.warehouseAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.warehouseInfo, "warehouseAddress", $$v)
                          },
                          expression: "warehouseInfo.warehouseAddress"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  style: _vm.isZh ? "margin-left:100px" : "",
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": _vm.isZh ? "100px" : "226px",
                    "label-position": _vm.isZh ? "left" : "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContactWay") } },
                    [
                      _vm.openWarehouse
                        ? _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { no: "9" },
                            model: {
                              value: _vm.warehouseInfo.warehouseContact,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warehouseInfo,
                                  "warehouseContact",
                                  $$v
                                )
                              },
                              expression: "warehouseInfo.warehouseContact"
                            }
                          })
                        : _vm._e(),
                      !_vm.openWarehouse
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "10",
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                "allow-create": true,
                                filterable: ""
                              },
                              on: {
                                change: _vm.contactsChangeHandler,
                                blur: _vm.selectContactBlur
                              },
                              model: {
                                value: _vm.warehouseInfo.warehouseContact,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.warehouseInfo,
                                    "warehouseContact",
                                    $$v
                                  )
                                },
                                expression: "warehouseInfo.warehouseContact"
                              }
                            },
                            _vm._l(_vm.contactList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.contactPerson,
                                  value: item.contactPerson
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t(
                          "SeaExport.EstimatedDateOfArrivalTheWarehouse"
                        )
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "11",
                          disabled: _vm.readonly,
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("queryJob.SelectDateAndTime")
                        },
                        model: {
                          value: _vm.warehouseInfo.arriveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.warehouseInfo, "arriveDate", $$v)
                          },
                          expression: "warehouseInfo.arriveDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t(
                          "SeaExport.EstimatedDateOfPickingUpTheContainer"
                        )
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "130px" },
                        attrs: {
                          no: "12",
                          disabled: _vm.readonly,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.job.esd,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "esd", $$v)
                          },
                          expression: "job.esd"
                        }
                      }),
                      _vm.isZh
                        ? [
                            _c("span", { staticStyle: { margin: "0 10px" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.DateOfReturningTheContainer"
                                  )
                                )
                              )
                            ]),
                            _c("el-date-picker", {
                              staticStyle: { width: "130px" },
                              attrs: {
                                no: "13",
                                disabled: _vm.readonly,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.job.returnDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "returnDate", $$v)
                                },
                                expression: "job.returnDate"
                              }
                            }),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { margin: "0 0 0 10px" },
                                attrs: { no: "14", disabled: _vm.readonly },
                                model: {
                                  value: _vm.job.quarantine,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "quarantine", $$v)
                                  },
                                  expression: "job.quarantine"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.SanitaryAndPhytosanitaryStandard"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  !_vm.isZh
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.DateOfReturningTheContainer"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              no: "13",
                              disabled: _vm.readonly,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.job.returnDate,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "returnDate", $$v)
                              },
                              expression: "job.returnDate"
                            }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { margin: "0 0 0 10px" },
                              attrs: { no: "14", disabled: _vm.readonly },
                              model: {
                                value: _vm.job.quarantine,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "quarantine", $$v)
                                },
                                expression: "job.quarantine"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.SanitaryAndPhytosanitaryStandard"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CargosExpectedArrivalDate")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "15",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.warehouseInfo.arriveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.warehouseInfo, "arriveDate", $$v)
                          },
                          expression: "warehouseInfo.arriveDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.LoadingRemarks") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "16",
                          type: "textarea",
                          rows: 5,
                          "filter-chars": false
                        },
                        model: {
                          value: _vm.warehouseInfo.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.warehouseInfo, "remarks", $$v)
                          },
                          expression: "warehouseInfo.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }